var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHhDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183.153,
    height: 55.315,
    viewBox: "0 0 183.153 55.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 183.153,
    height: 55.315,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-hh-desktop",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 16.785,
    height: 9.073,
    transform: "translate(52.541 23.121)",
    fill: "#19a5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 16.785,
    height: 9.073,
    transform: "translate(4.537 23.121)",
    fill: "#19a5f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M12.348,55.315C4.27,47,0,37.435,0,27.658S4.27,8.317,12.348,0l6.508,6.322c-6.4,6.588-9.783,13.966-9.783,21.336S12.456,42.4,18.857,48.993Z",
    transform: "translate(0 0)",
    fill: "#19a5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M119.093,55.315l-6.509-6.322c6.4-6.588,9.783-13.966,9.783-21.335s-3.382-14.747-9.783-21.336L119.093,0c8.078,8.317,12.348,17.88,12.348,27.658S127.171,47,119.093,55.315",
    transform: "translate(-57.578 0)",
    fill: "#19a5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M43.429,39.658H34.356c0-5.723,2.371-11.322,6.856-16.193l6.674,6.146c-2.916,3.167-4.457,6.641-4.457,10.047",
    transform: "translate(-17.57 -12.001)",
    fill: "#7507fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M41.212,72.8c-4.486-4.871-6.856-10.471-6.856-16.193h9.073c0,3.406,1.541,6.88,4.457,10.047Z",
    transform: "translate(-17.57 -28.951)",
    fill: "#7507fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M95.8,72.8,89.13,66.656c2.916-3.167,4.457-6.641,4.457-10.047h9.073c0,5.723-2.371,11.322-6.856,16.193",
    transform: "translate(-45.583 -28.951)",
    fill: "#7507fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M102.661,39.658H93.588c0-3.406-1.542-6.88-4.458-10.047L95.8,23.465c4.485,4.871,6.857,10.471,6.857,16.193",
    transform: "translate(-45.583 -12.001)",
    fill: "#7507fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 31.219,
    height: 9.073,
    transform: "translate(21.322 23.121)",
    fill: "#7507fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M187.077,2.536V24.3H182.49V13.851l2.065,1.387H172.547l2.065-1.327V24.3h-4.588V2.536h4.588V13.054l-2.065-1.371h12.008l-2.065,1.371V2.536Z",
    transform: "translate(-86.954 -1.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M217.088,30.968a6.125,6.125,0,0,1-2.744-.538,4.346,4.346,0,0,1-1.7-1.453,5.877,5.877,0,0,1-.871-2.036,10.347,10.347,0,0,1-.251-2.272V15.006H216.1v8.453a7,7,0,0,0,.221,1.815,2.539,2.539,0,0,0,.819,1.328,2.58,2.58,0,0,0,1.7.5,2.8,2.8,0,0,0,1.829-.612,3.923,3.923,0,0,0,1.151-1.571,5.114,5.114,0,0,0,.4-1.977l1.283,1.048a8.147,8.147,0,0,1-.45,2.744,6.834,6.834,0,0,1-1.276,2.221,5.733,5.733,0,0,1-2.014,1.482,6.487,6.487,0,0,1-2.677.531m5.134-15.962H226.8V30.673h-4.573Z",
    transform: "translate(-108.18 -7.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M249.112,14.7h4.573V30.364h-4.573Zm11.035,15.667v-8.5a5.953,5.953,0,0,0-.251-1.777A2.5,2.5,0,0,0,259,18.8a3.084,3.084,0,0,0-1.874-.487,3.378,3.378,0,0,0-1.836.487,3.163,3.163,0,0,0-1.188,1.357,4.629,4.629,0,0,0-.413,2.007l-1.269-.915a7.021,7.021,0,0,1,.885-3.57,6.43,6.43,0,0,1,2.4-2.4,6.6,6.6,0,0,1,3.356-.871,5.935,5.935,0,0,1,3.179.774,4.731,4.731,0,0,1,1.859,2.154,7.892,7.892,0,0,1,.612,3.224v9.81Z",
    transform: "translate(-127.401 -7.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M292.875,25.593a11.533,11.533,0,0,1-1.851-.155,5.268,5.268,0,0,1-1.771-.62,3.463,3.463,0,0,1-1.32-1.365,4.869,4.869,0,0,1-.5-2.375V13.143h-3.615V9.6h1.018a10.566,10.566,0,0,0,1.409-.074,1.2,1.2,0,0,0,.782-.376,1.768,1.768,0,0,0,.332-.951,16.788,16.788,0,0,0,.074-1.785V4.439h4.588V9.6h4.558v3.541h-4.558v6.638a4.69,4.69,0,0,0,.243,1.652q.243.635,1.217.635a4.612,4.612,0,0,0,.922-.089,4.016,4.016,0,0,0,.657-.177v3.437a4.508,4.508,0,0,1-.87.244,6.9,6.9,0,0,1-1.313.11",
    transform: "translate(-145.15 -2.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M314.388,23.9V20.878h10.386l-.443.767V21.2a3.485,3.485,0,0,0-.4-1.615,3.145,3.145,0,0,0-1.232-1.268,4.132,4.132,0,0,0-2.132-.494,4.316,4.316,0,0,0-2.235.553,3.594,3.594,0,0,0-1.431,1.586,5.73,5.73,0,0,0-.494,2.493,6.267,6.267,0,0,0,.479,2.574,3.576,3.576,0,0,0,1.431,1.645,4.5,4.5,0,0,0,2.368.575,6.451,6.451,0,0,0,1.579-.17,3.775,3.775,0,0,0,1.084-.435,2.137,2.137,0,0,0,.642-.59,1.507,1.507,0,0,0,.265-.634h4.514a4.4,4.4,0,0,1-.679,1.94,6.1,6.1,0,0,1-1.637,1.711,8.312,8.312,0,0,1-2.545,1.2,12.062,12.062,0,0,1-3.416.443,9.416,9.416,0,0,1-4.529-1.04,7.471,7.471,0,0,1-2.995-2.877,8.32,8.32,0,0,1-1.062-4.241,8.241,8.241,0,0,1,1.085-4.271,7.5,7.5,0,0,1,3.024-2.862,9.472,9.472,0,0,1,4.492-1.026,9.276,9.276,0,0,1,4.514,1.04,7.269,7.269,0,0,1,2.936,2.906,8.834,8.834,0,0,1,1.032,4.344q0,.369-.015.708a4.071,4.071,0,0,1-.044.5Z",
    transform: "translate(-159.517 -7.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M351.832,30.364V14.7h4.588v5.4l-.944-.59a7.428,7.428,0,0,1,.59-2.036,5.609,5.609,0,0,1,1.107-1.615,4.8,4.8,0,0,1,1.615-1.069,5.631,5.631,0,0,1,2.147-.384,6.16,6.16,0,0,1,1.482.14,3.771,3.771,0,0,1,.671.214l-.752,4.1a4.86,4.86,0,0,0-.59-.236,3.587,3.587,0,0,0-1.18-.163,4.392,4.392,0,0,0-1.977.4,3.461,3.461,0,0,0-1.276,1.054,4.247,4.247,0,0,0-.686,1.454,6.4,6.4,0,0,0-.206,1.608v7.391Z",
    transform: "translate(-179.935 -7.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M176.541,89.488a11.49,11.49,0,0,1-4.064-.679,6.422,6.422,0,0,1-2.855-2,5.048,5.048,0,0,1-1.047-3.238,4.832,4.832,0,0,1,.818-2.773,9.168,9.168,0,0,1,2.375-2.3,38.3,38.3,0,0,1,3.769-2.287,10.688,10.688,0,0,0,2.788-2.043,3.043,3.043,0,0,0,.87-2.029,1.965,1.965,0,0,0-.28-1.084,1.878,1.878,0,0,0-.752-.671,2.344,2.344,0,0,0-1.062-.236,2.481,2.481,0,0,0-1.055.229,1.947,1.947,0,0,0-.8.663,1.854,1.854,0,0,0-.3,1.084,3.818,3.818,0,0,0,.6,1.918,17.984,17.984,0,0,0,1.542,2.183l7.435,8.984a2.669,2.669,0,0,0,1.018.826,2.328,2.328,0,0,0,.782.177,2.911,2.911,0,0,0,.686-.088q.361-.089.524-.148v3.172q-.089.029-.576.155a5.168,5.168,0,0,1-1.254.125,4.852,4.852,0,0,1-1.755-.361,3.829,3.829,0,0,1-1.593-1.173l-8.084-9.663q-.679-.841-1.4-1.837a11.1,11.1,0,0,1-1.21-2.124,5.882,5.882,0,0,1-.487-2.353,4.02,4.02,0,0,1,.76-2.383,5.352,5.352,0,0,1,2.087-1.711,6.934,6.934,0,0,1,3.054-.642,6.79,6.79,0,0,1,3.038.634,4.979,4.979,0,0,1,1.991,1.7,4.185,4.185,0,0,1,.708,2.375,5.5,5.5,0,0,1-.642,2.671,7.575,7.575,0,0,1-1.859,2.19,20.711,20.711,0,0,1-2.943,2,23.4,23.4,0,0,0-3.415,2.279,2.989,2.989,0,0,0-1.173,2.338,2.336,2.336,0,0,0,.516,1.483,3.425,3.425,0,0,0,1.38,1.025,4.8,4.8,0,0,0,1.91.369,7.409,7.409,0,0,0,3.046-.56,6.652,6.652,0,0,0,2.117-1.475,6.867,6.867,0,0,0,1.976-5.178h3.718a10.865,10.865,0,0,1-.435,3.216,9.6,9.6,0,0,1-1.144,2.471,11.256,11.256,0,0,1-1.563,1.9,9.807,9.807,0,0,1-3.268,2.08,11.9,11.9,0,0,1-4.492.8",
    transform: "translate(-86.213 -34.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M246.408,67.605V89.365H241.82V78.92l2.065,1.387H231.877l2.066-1.327V89.365h-4.588V67.605h4.588V78.124l-2.066-1.372h12.008l-2.065,1.372V67.605Z",
    transform: "translate(-117.297 -34.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M272.665,70.358a3.111,3.111,0,0,1-1.851-.56,1.988,1.988,0,0,1,0-3.172,3.36,3.36,0,0,1,3.717,0,1.838,1.838,0,0,1,.79,1.593,1.82,1.82,0,0,1-.79,1.586,3.168,3.168,0,0,1-1.866.553m-2.257,2.552h4.529V88.577h-4.529Z",
    transform: "translate(-138.097 -33.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M286.438,95.434V79.767h4.588v5.4l-.944-.59a7.429,7.429,0,0,1,.59-2.036,5.61,5.61,0,0,1,1.107-1.615,4.8,4.8,0,0,1,1.615-1.069,5.631,5.631,0,0,1,2.147-.384,6.16,6.16,0,0,1,1.482.14,3.769,3.769,0,0,1,.671.214l-.752,4.1a4.859,4.859,0,0,0-.59-.236,3.587,3.587,0,0,0-1.18-.163,4.392,4.392,0,0,0-1.977.4,3.461,3.461,0,0,0-1.276,1.054,4.248,4.248,0,0,0-.686,1.454,6.377,6.377,0,0,0-.206,1.608v7.391Z",
    transform: "translate(-146.491 -40.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M313.12,88.972V85.948h10.386l-.443.767v-.443a3.491,3.491,0,0,0-.4-1.615,3.145,3.145,0,0,0-1.232-1.268,4.132,4.132,0,0,0-2.132-.494,4.316,4.316,0,0,0-2.235.553,3.594,3.594,0,0,0-1.431,1.586,5.73,5.73,0,0,0-.494,2.493,6.266,6.266,0,0,0,.479,2.574,3.578,3.578,0,0,0,1.431,1.645,4.506,4.506,0,0,0,2.368.575,6.451,6.451,0,0,0,1.579-.17,3.774,3.774,0,0,0,1.084-.435,2.137,2.137,0,0,0,.642-.59,1.509,1.509,0,0,0,.265-.634H327.5a4.4,4.4,0,0,1-.679,1.94,6.1,6.1,0,0,1-1.637,1.711,8.316,8.316,0,0,1-2.545,1.2,12.061,12.061,0,0,1-3.416.443,9.416,9.416,0,0,1-4.529-1.04,7.472,7.472,0,0,1-3-2.877,8.974,8.974,0,0,1,.022-8.512A7.5,7.5,0,0,1,314.75,80.5a9.47,9.47,0,0,1,4.491-1.026,9.276,9.276,0,0,1,4.514,1.04,7.269,7.269,0,0,1,2.936,2.906,8.834,8.834,0,0,1,1.032,4.344q0,.369-.015.708a4.07,4.07,0,0,1-.044.5Z",
    transform: "translate(-158.869 -40.644)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHhDesktop);
export default __webpack_public_path__ + "static/media/logo-hh-desktop.04f723c7067599e26c835493710c0887.svg";
export { ForwardRef as ReactComponent };